import { createReducer, on } from '@ngrx/store';
import * as ReasonActions from './reason.actions';
import { Reason } from '../../models/Reason';

export interface ReasonState {
  reasons: Reason[] | null;
}

export const initialState: ReasonState = {
  reasons: null
};

export const reasonReducer = createReducer(
  initialState,
  on(ReasonActions.getReasonsSuccess, (state, { reasons }) => ({
    ...state,
    reasons
  }))
);
